import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import type { AppRouteData } from './route-data';

const DEFAULT_PRELOAD_DELAY_MS = 1200;

/**
 * Selective route preloading — only routes with `data.preload === true`.
 * Waits until after initial paint so login/dashboard stay fast.
 */
@Injectable({ providedIn: 'root' })
export class CustomPreloadingStrategy implements PreloadingStrategy {
  private readonly platformId = inject(PLATFORM_ID);

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (!isPlatformBrowser(this.platformId)) {
      return of(null);
    }

    const data = route.data as AppRouteData | undefined;
    if (data?.preload !== true) {
      return of(null);
    }

    const delayMs =
      typeof data.preloadDelayMs === 'number' && data.preloadDelayMs >= 0
        ? data.preloadDelayMs
        : DEFAULT_PRELOAD_DELAY_MS;

    return timer(delayMs).pipe(mergeMap(() => load()));
  }
}
